export function logHttpError(type, observabilityFns, params) {
    const { analytics, errors, metrics } = observabilityFns || {};
    analytics.track('frontend.data.error', params);
    const metricTags = {
        service: params.service,
        project: params.project,
        error_expected: params.errorExpected,
        operation_name: params.operationName
    };
    metrics.increment('frontend.data.error', metricTags);
    if (params.errorExpected || params.project === '<unknown>') {
        return;
    }
    const sentryParams = params;
    const project = params.project;
    const errorCode = params.errorCode;
    const operationName = params.operationName;
    const errorMessage = `${type} error '${errorCode}' on operation '${operationName}'`;
    errors.error(errorMessage, {
        project,
        extras: sentryParams
    });
}
export function logHttpSuccess(type, observabilityFns, params) {
    const { analytics, metrics } = observabilityFns || {};
    analytics.track('frontend.data.success', params);
    const metricTags = {
        service: params.service,
        project: params.project,
        operation_name: params.operationName
    };
    metrics.increment('frontend.data.success', metricTags);
}

//# sourceMappingURL=logHttp.js.map